import { memo } from 'react';
import useDisplayImage from '@/src/hooks/useDisplayImage';
import { list } from './constants';

import styles from './style.module.scss';

const Record = ({
  index,
}) => {
  const displayImg = useDisplayImage();

  return (
    <div className={styles.container}>
      <div className={styles.midLine} />
      <div className={styles.wrap}>
        {new Array(4).fill('').map((_, subIndex) => (
          <div
            className={styles.recordItem}
            key={subIndex}
            onClick={() => displayImg(
              // eslint-disable-next-line max-len
              `https://blcdnsmall.nikkigames.cn/sdk/poster/evolweb/secondary/gallery/${index * 4 + 1 + subIndex}-min.jpg`,
            )}
          >
            <div className={styles.midIcon}>
              <div className={styles.rect} />
              <div className={styles.borderRect} />
            </div>

            <div className={`${styles.itemImg} ${styles[`itemImg${index * 4 + 1 + subIndex}`]}`}>
              <div className={styles.title}>
                {list[index * 4 + subIndex]}
              </div>
            </div>
            <div className={styles.cover}>
              点击查看大图
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(Record);
